import React from "react";
import Modal from 'react-bootstrap/Modal'

import Separator from "../common/Separator";

import Notify from "../../../utils/Notify";
import Backend from "../../../utils/Backend";
import Select from "../common/Select";


export default class Mappings extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      show: props.show,
      form: props.form,
      csvFile: props.csvFile,
      template: props.template,
      name: "",
      columns: {},
      csvFileColumns: [],
      loading: true,
      initialLoading: true,
      mapping: props.mapping,
    }
  }

  componentDidMount() {
    const { csvFile, mapping } = this.state;
    const reader = new FileReader();

    if(mapping){
      this.setState({
        name: mapping.name,
        form: mapping.form,
        columns: mapping.columns,
      })
      this._setColumns()
      return
    }

    reader.onload = (e) => {
      const csvText = e.target.result;
      const csvFileColumns = this._getCsvColumns(csvText);
      this.setState({ csvFileColumns });
      this._setColumns()
    };

    reader.readAsText(csvFile);
  }

  _getCsvColumns(csvData) {
    const firstLine = csvData.trim().split(/\r?\n/)[0];
    return firstLine.split(",").map(col => col.trim());
  }

  _isFormValid(){
    const { name } = this.state;

    let error = null
    if(!name){
      error ="Please specify a valid name"
    }

    if(error){
      Notify.error(error)
      return false
    }
    return true
  }

  _setColumns() {
    const { parser, mapping } = this.props
    Backend.getColumns(parser)
    .then(response => {
      let columns  = {}
      response.forEach(key => {
        columns[key] = mapping?.columns[key] || ""
      })
      this.setState({columns, initialLoading: false, loading: false})
    })
  }

  _save() {
    const { name, form, columns } = this.state
    if(!this._isFormValid()){
      return
    }

    const data = {
      name,
      form: form.id,
      parser: this.props.parser,
    }

    const nonEmptyColumns = {}
    Object.keys(columns).map(key => {
      const value = columns[key]
      if(value && value.trim() !== ""){
        nonEmptyColumns[key] = value
      }
    })

    data.columns = nonEmptyColumns

    this.setState({loading: true})
    this._handleBackend(data)
      .then(mapping => {
        this.props.onCreated(mapping)
        Notify.success(mapping ? "Successfully created mapping" : "Mapping Updated")
        this.setState({loading: false})
      })
      .catch(error => {
        Notify.error(error.message)
        this.setState({loading: false})
      })
  }

  _handleBackend(data){
    if(this.props.mapping){
      return Backend.updateMapping(this.props.mapping, data)
    }
    return Backend.saveMapping(data)
  }

  _renderContent(){
    const { initialLoading, columns, csvFileColumns } = this.state;

    if (initialLoading) {
      return (
        <p>Loading...</p>
      )
    }

    return Object.keys(columns).map(key => {
      const value = columns[key];
      return (
        <div className="row mb-4">
          <div className="col-md-6">
            {key}:
          </div>
          <div className="col-md-6">
            { this.state.mapping ? (
                <input
                  type="text"
                  placeholder={key}
                  defaultValue={value}
                  className="form-control form-control-solid h-auto"
                  onChange={(e) => {
                    columns[key] = e.target.value || null
                    this.setState({columns})
                  }}
                />
              ) : (
                <Select
                  isClearable={true}
                  value={value}
                  options={csvFileColumns}
                  placeholder={key}
                  getOptionLabel={(value) => value}
                  getOptionValue={(value) => value}
                  className="form-control form-control-solid h-auto c-selectbox"
                  classNamePrefix="filter-select"
                  onSelected={(value) => {
                    columns[key] = value
                    this.setState({columns})
                  }}
                />
              )
            }
          </div>
        </div>
      )
    })
  }

  render() {
    let {
      show,
      name,
      loading
    } = this.state

    return (
      <>
        <Modal
          show={show}
          onHide={() => this.props.onHide()}
          backdrop='static'
          className={'sub-modal'}
          dialogClassName={"modal-50"}
        >
          <Modal.Header closeButton>
            <Modal.Title>Create Mapping</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="flex-column" data-kt-stepper-element="content">
              <div className="row">

                <div className="col-md-12">
                  <div className="fv-row mb-3">
                    <div className="form-floating mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        value={name}
                        onChange={e => {
                          this.setState({name: e.target.value || null })
                        }}
                      />
                      <div className="position-absolute translate-middle-y top-50 end-0 me-3">
                        <i className="fas fa-exclamation-circle ms-2 fs-7" data-bs-toggle="tooltip" title=""
                           data-bs-original-title="Description of Field" aria-label="Description of Field"></i>
                      </div>
                      <label htmlFor="declarantName">Name</label>
                    </div>
                  </div>
                </div>

              </div>

              <Separator text={"Columns"}/>

              {this._renderContent()}

            </div>
            <div className=" d-flex justify-content-end py-6">
              <button
                className="btn btn-primary px-6"
                id="addProductCode"
                disabled={loading}
                onClick={() => this._save()}
              >
                { loading ? "Loading..." : "Save" }
              </button>
            </div>
          </Modal.Body>

        </Modal>
      </>
    )
  }

}
